// extracted by mini-css-extract-plugin
export default {"sizes":"\"../../cssvariables/media.module.css\"","tablet-to":"screen and (min-width : 768px)","box":"styles_box__1V0CP"};